import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// httpOnly cookies are set by the backend; sent automatically with withCredentials.
// No tokens are stored in localStorage — protects against XSS exfiltration.
export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// ----- Public submissions -----
export const submitContact = (data) => apiClient.post("/contact", data).then((r) => r.data);
export const subscribeNewsletter = (data) => apiClient.post("/newsletter", data).then((r) => r.data);
export const submitPartnership = (data) => apiClient.post("/partnership", data).then((r) => r.data);
export const submitVolunteer = (data) => apiClient.post("/volunteer", data).then((r) => r.data);

// ----- Auth -----
export const adminLogin = (email, password) =>
  apiClient.post("/auth/login", { email, password }).then((r) => r.data);
export const adminLogout = () => apiClient.post("/auth/logout").then((r) => r.data);
export const adminMe = () => apiClient.get("/auth/me").then((r) => r.data);

// ----- Admin data -----
export const adminStats = () => apiClient.get("/admin/stats").then((r) => r.data);
export const adminContact = () => apiClient.get("/admin/contact").then((r) => r.data);
export const adminNewsletter = () => apiClient.get("/admin/newsletter").then((r) => r.data);
export const adminPartnership = () => apiClient.get("/admin/partnership").then((r) => r.data);
export const adminVolunteer = () => apiClient.get("/admin/volunteer").then((r) => r.data);
